import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {stopOrderProcessing} from '../../../../actions/site-actions';
import CheckoutOverlay from '../../CheckoutOverlay';
import AdyenV2ActionOverlayLazyLoader from './AdyenV2ActionOverlayLazyLoader';

export function AdyenV2ActionOverlay(props) {
  return (
    <CheckoutOverlay
      popup
      nopadding
      stickyHeader
      fullscreenMobile
      exitCallback={props.stopOrderProcessing}
    >
      <AdyenV2ActionOverlayLazyLoader {...props} />
    </CheckoutOverlay>
  );
}

AdyenV2ActionOverlay.propTypes = {
  stopOrderProcessing: PropTypes.func.isRequired,
};

export default connect(null, {stopOrderProcessing})(AdyenV2ActionOverlay);
